module.exports = __webpack_public_path__ + "Images/w_maximize.png";


//////////////////
// WEBPACK FOOTER
// ./Images/w_maximize.png
// module id = 1872
// module chunks = 2